<script>
  export default {
    props: {
      error: {
        type: Object,
        required: true
      }
    }
  }
</script>

<template>
  <div class="invalid-feedback is-visible">
    {{ $t('validation.' + Object.keys(error)[0]) }}
  </div>
</template>

